import type {
	Version,
	Status as StatusType,
	IssuesStatus as IssuesStatusType,
} from '../model/index.tsx';
import { ARCHIVED, RELEASED, UNRELEASED } from '../model/status.tsx';
import type {
	Version as RestVersion,
	IssueStatusForVersion,
	UnresolvedIssuesCount as RestUnresolvedIssuesCount,
} from '../rest/types.tsx';

const transformStatus = (archived: boolean, released: boolean): StatusType => {
	if (archived) {
		return ARCHIVED;
	}
	if (released) {
		return RELEASED;
	}
	return UNRELEASED;
};

const transformIssuesStatus = ({
	toDo,
	inProgress,
	done,
}: IssueStatusForVersion): IssuesStatusType => ({
	toDo,
	inProgress,
	done,
});

export const transformVersion = (restVersion: RestVersion): Version => {
	const version: Version = {
		id: restVersion.id,
		name: restVersion.name,
		description: restVersion.description ? restVersion.description : '',
		status: transformStatus(restVersion.archived, restVersion.released),
		startDate: restVersion.startDate,
		releaseDate: restVersion.releaseDate,
		overdue: !!restVersion.overdue,
		projectId: restVersion.projectId,
	};
	if (restVersion.issuesStatusForFixVersion) {
		version.issuesStatus = transformIssuesStatus(restVersion.issuesStatusForFixVersion);
	}
	return version;
};

export const transformUnresolvedIssuesCount = (rest: RestUnresolvedIssuesCount): number =>
	rest.issuesUnresolvedCount;
